import { createIsomorphicFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

export const getPreferredLanguage = createIsomorphicFn()
  .server(() => {
    const request = getRequest();
    const acceptLanguage = request.headers.get('accept-language');

    if (acceptLanguage) {
      return acceptLanguage.split(',')[0].trim();
    }
  })
  .client(() => {
    return navigator.language;
  });
